<template>
    <div class="d-flex">
        <img src="/images/logo_lifeed.png" class="brand-image header-height" @click="redirectToHome"/>
    </div>
</template>

<script>
import MenuCompanyLogo from '../atoms/MenuCompanyLogo';
import { mapGetters } from 'vuex';

export default {
    name: "MenuLogos",
    components: {
        MenuCompanyLogo
    },
    methods: {
        redirectToHome() {
            this.$router.push({name: 'servicedashboard'}).catch(() => {});
        }
    },
    computed: {
        ...mapGetters({
            currentService: 'user/getUserCurrentService'
        })
    }
}
</script>

<style lang="scss" scoped>
    .brand-image {
        cursor: pointer;
        margin: 0;
    }

    .menu-container {
        width: 200px
    }

    .company-logo {
        height: 45px;
    }

</style>
